import { render, staticRenderFns } from "./reelsComments.vue?vue&type=template&id=2a8a1702&lang=html"
import script from "./reelsComments.vue?vue&type=script&lang=js"
export * from "./reelsComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports